import { render, staticRenderFns } from "./ReportsDialog.vue?vue&type=template&id=79f5e85d&scoped=true"
import script from "./ReportsDialog.vue?vue&type=script&lang=js"
export * from "./ReportsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f5e85d",
  null
  
)

export default component.exports